export default {
  // Page Header
  page_header: {
    title: "Вашите Канали",
    description: "В тази страница можете да намерите информация за Lab Portal.",
    action_buttons: {
      refresh: {
        label: "Обновяване на каналите",
        tooltip: "Обновяване на списъка с канали",
      },
    },
  },

  // Content
  channel_card: {
    action_buttons: {
      start: "Стартиране",
      stop: "Спиране",
    },
  },
  channel: "канал",
  channels: "канала",
  online: "Онлайн",
  offline: "Офлайн",
  connected: "Свързан",
  not_connected: "Не е свързан",
  instrument_name: "Име на апарат",
  driver_id: "ID на драйвера",
  port: "Порт",

  // Empty State
  no_channels_title: "Няма налични канали",
  no_channels_description:
    "В момента няма конфигурирани канали. Моля, проверете връзката или обновете.",
  refresh_channels: "Обновяване на канали",
};
